import { render, staticRenderFns } from "./userAssignment.vue?vue&type=template&id=7efd79c1&scoped=true&"
import script from "./userAssignment.vue?vue&type=script&lang=js&"
export * from "./userAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efd79c1",
  null
  
)

export default component.exports